import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { HvSubstationSubmission } from "../../shared/interfaces/HvSubstation";

export function useHvSubstationUpdate(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationKey: ["updateHvSubstation"],
    mutationFn: (hvSubstation: HvSubstationSubmission) => apiContext.hvSubstationApis.updateHvSubstation(hvSubstation),
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
